import React, { useState, useEffect, useRef } from 'react';

import { useTimer } from '../../context/TimerContext';

import { usePageControl } from '../../context/PageControlContext';
import PageNavigation from '../../components/PageNavigation';

import Popup from '../../components/Popup';
import { usePopupVideoAutoClose } from "../../hooks/usePopupVideoAutoClose";

function Module4() {

  // Page nav control
  const { canContinue, setCanContinue } = usePageControl();
  
  useEffect(() => {
    setCanContinue(true);
  }, [setCanContinue]);
  
  // Popup
  const [showPopup, setShowPopup] = useState(false);

  // - Time-based popup after page load
  const showAfterSeconds = 2; // Seconds

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPopup(true);
    }, showAfterSeconds * 1000);

    return () => clearTimeout(timer);
  }, []);

  // - Manual popup trigger using class
  useEffect(() => {
    const triggers = document.querySelectorAll('.popup-trigger');
    triggers.forEach(trigger =>
      trigger.addEventListener('click', () => setShowPopup(true))
    );

    return () => {
      triggers.forEach(trigger =>
        trigger.removeEventListener('click', () => setShowPopup(true))
      );
    };
  }, []);


  // Popup Video Auto Close
  const {
    videoRef,
    handlePlay,
    handlePopupVideoEnded,
    cancelPopupAutoClose
  } = usePopupVideoAutoClose({ showPopup, setShowPopup });


  // Timer
  const { timeRemaining, formatTime, isRunning } = useTimer();
    
  // Determine additional classes dynamically
  let additionalClasses = '';
    if (isRunning) {
      additionalClasses += ' timer-running';
    }
    if (timeRemaining <= 600 && timeRemaining >= 0) { // 10 mins or less but not negative
      additionalClasses += ' timer-warning';
    }
    if (timeRemaining < 0) { // time exceeded
      additionalClasses += ' timer-exceeded';
    } 


  return (
    <div id="module-4" className="page physical">
        
        <header className="container-fluid">
            <div className="row">
                <div className="col-12">
                  <div id="CER"></div>
                  <div id="line"></div>
                  <div className={`timer-display${additionalClasses}`}>
                    <span className="timer-text">Time remaining <span className="timer-numbers">{formatTime(timeRemaining)}</span></span>
                  </div>
                </div>
            </div>
        </header>
    
        <main className="container-fluid">
            <div className="row">
                <div className="col-12">
                  <div id="box-wrapper-email">

                    <div id="email-client">
                      <div id="email-client-header"><h1 id="email-client-header-title">Email</h1></div>
                      <div id="email-client-body">
                        <div id="email-client-sidebar"><h2 id="email-client-sidebar-title">Inbox</h2></div>
                        <div id="email-client-content">

                          <div className="email">
                            <div className="email-header">
                              From: les.gettam@met.police.uk
                              <div className="email-attachment popup-trigger" style={{ cursor: 'pointer', color: 'blue' }}>Video</div>                         
                            </div>
                            <div className="email-body">
                              <h2 className="email-subject">Subject: Ransomware!</h2>
                              <p>What the...? Ransomware? That's all we need. With her files encrypted by this, we're never going to find out what's happened here.</p>

                              <p>I don't need to tell you that cyber criminals use Ransomware to encrypt people's files, and demand payment to unlock them, but we're not gonna go down that route...</p>

                              <p>See if you can find another way past this, I'll be in touch when you've got it sorted.</p>

                              <p>DS Les Gettam</p>
                            </div>
                          </div>

                      </div>
                    </div>

                    </div>
                  </div>

      <Popup
        className="popup-box-video"
        title="DS Les Gettam"
        isOpen={showPopup}
        onClose={() => setShowPopup(false)}
        footer={
        <>
          <button onClick={handlePlay} className={"btn" + " " + "btn-video" + " " + "btn-video-play"}><span className="visually-hidden">Play video</span></button>
          <button onClick={() => setShowPopup(false)} className={"btn" + " " + "btn-video" + " " + "btn-video-close"}><span className="visually-hidden">Close video</span></button>
        </>
        }
      >
      <video
        ref={videoRef}
        controls
        onPlay={cancelPopupAutoClose} // make sure an auto-close timer isn't running on play
        onEnded={() => handlePopupVideoEnded(3)} // auto-close after X seconds when video ends
        controlsList="nodownload nofullscreen noremoteplayback"
        disablePictureInPicture
      >
        <source src={`/videos/02.mp4`} type="video/mp4" />
        Your browser does not support the video tag.
        <track src={`/videos/02.vtt`} kind="subtitles" srcLang="en" label="English" default></track>
      </video>
      </Popup>

                </div>
            </div>
        </main>

        <footer className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <PageNavigation />
                </div>
            </div>
        </footer>
    
    </div>
  );
};

export default Module4;
